import type { Institution, Program, ApplicationWindow } from '@admitly/types';

// Mock Institutions Data
export const mockInstitutions: Institution[] = [
  {
    id: '1',
    slug: 'university-of-lagos',
    name: 'University of Lagos',
    short_name: 'UNILAG',
    type: 'federal_university',
    state: 'Lagos',
    city: 'Yaba',
    address: 'Akoka, Yaba, Lagos',
    logo_url: '/logos/unilag.png',
    website: 'https://www.unilag.edu.ng',
    email: 'info@unilag.edu.ng',
    phone: '+234 1 493 4072',
    description:
      'Premier institution of learning with a focus on excellence in teaching, research and community service.',
    verified: true,
    status: 'published',
    program_count: 156,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
  {
    id: '2',
    slug: 'university-of-ibadan',
    name: 'University of Ibadan',
    short_name: 'UI',
    type: 'federal_university',
    state: 'Oyo',
    city: 'Ibadan',
    address: 'Ibadan, Oyo State',
    logo_url: '/logos/ui.png',
    website: 'https://www.ui.edu.ng',
    email: 'info@ui.edu.ng',
    phone: '+234 2 810 1100',
    description: "Nigeria's premier university and the first university in Nigeria.",
    verified: true,
    status: 'published',
    program_count: 142,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
  {
    id: '3',
    slug: 'obafemi-awolowo-university',
    name: 'Obafemi Awolowo University',
    short_name: 'OAU',
    type: 'federal_university',
    state: 'Osun',
    city: 'Ile-Ife',
    address: 'Ile-Ife, Osun State',
    logo_url: '/logos/oau.png',
    website: 'https://www.oauife.edu.ng',
    email: 'info@oauife.edu.ng',
    phone: '+234 36 230 290',
    description: 'A world-class institution with a focus on academic excellence and innovation.',
    verified: true,
    status: 'published',
    program_count: 128,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
  {
    id: '4',
    slug: 'ahmadu-bello-university',
    name: 'Ahmadu Bello University',
    short_name: 'ABU',
    type: 'federal_university',
    state: 'Kaduna',
    city: 'Zaria',
    address: 'Zaria, Kaduna State',
    logo_url: '/logos/abu.png',
    website: 'https://www.abu.edu.ng',
    email: 'info@abu.edu.ng',
    phone: '+234 69 550 581',
    description: 'The largest university in Nigeria and the second largest in Africa.',
    verified: true,
    status: 'published',
    program_count: 178,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
  {
    id: '5',
    slug: 'covenant-university',
    name: 'Covenant University',
    short_name: 'CU',
    type: 'private_university',
    state: 'Ogun',
    city: 'Ota',
    address: 'Canaanland, Ota, Ogun State',
    logo_url: '/logos/covenant.png',
    website: 'https://www.covenantuniversity.edu.ng',
    email: 'info@covenantuniversity.edu.ng',
    phone: '+234 1 790 4724',
    description:
      'A leading private Christian mission university committed to raising a new generation of leaders.',
    verified: true,
    status: 'published',
    program_count: 68,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
  {
    id: '6',
    slug: 'lagos-state-university',
    name: 'Lagos State University',
    short_name: 'LASU',
    type: 'state_university',
    state: 'Lagos',
    city: 'Ojo',
    address: 'Ojo, Lagos State',
    logo_url: '/logos/lasu.png',
    website: 'https://www.lasu.edu.ng',
    email: 'info@lasu.edu.ng',
    phone: '+234 1 773 4297',
    description: 'A state university committed to excellence in learning, research and innovation.',
    verified: true,
    status: 'published',
    program_count: 94,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
  {
    id: '7',
    slug: 'yaba-college-of-technology',
    name: 'Yaba College of Technology',
    short_name: 'YABATECH',
    type: 'polytechnic',
    state: 'Lagos',
    city: 'Yaba',
    address: 'Yaba, Lagos State',
    logo_url: '/logos/yabatech.png',
    website: 'https://www.yabatech.edu.ng',
    email: 'info@yabatech.edu.ng',
    phone: '+234 1 820 0879',
    description: 'One of the premier polytechnics in Nigeria offering quality technical education.',
    verified: true,
    status: 'published',
    program_count: 82,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
  {
    id: '8',
    slug: 'university-of-nigeria',
    name: 'University of Nigeria',
    short_name: 'UNN',
    type: 'federal_university',
    state: 'Enugu',
    city: 'Nsukka',
    address: 'Nsukka, Enugu State',
    logo_url: '/logos/unn.png',
    website: 'https://www.unn.edu.ng',
    email: 'info@unn.edu.ng',
    phone: '+234 42 771 911',
    description: 'The first autonomous indigenous and first full-fledged university in Nigeria.',
    verified: true,
    status: 'published',
    program_count: 134,
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
];

// Mock Programs Data
export const mockPrograms: Program[] = [
  {
    id: 'p1',
    institution_id: '1',
    slug: 'computer-science-unilag',
    name: 'Computer Science',
    degree_type: 'undergraduate',
    duration_years: 4,
    mode: 'full_time',
    accreditation_status: 'NUC Accredited',
    description:
      'A comprehensive program covering software development, algorithms, data structures, and emerging technologies.',
    tuition_per_year: 180000,
    acceptance_fee: 50000,
    cutoff_score: 250,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[0],
  },
  {
    id: 'p2',
    institution_id: '1',
    slug: 'medicine-surgery-unilag',
    name: 'Medicine and Surgery',
    degree_type: 'undergraduate',
    duration_years: 6,
    mode: 'full_time',
    accreditation_status: 'MDCN Accredited',
    description:
      'A rigorous medical program training future physicians with comprehensive clinical and theoretical knowledge.',
    tuition_per_year: 350000,
    acceptance_fee: 100000,
    cutoff_score: 290,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[0],
  },
  {
    id: 'p3',
    institution_id: '1',
    slug: 'law-unilag',
    name: 'Law',
    degree_type: 'undergraduate',
    duration_years: 5,
    mode: 'full_time',
    accreditation_status: 'NUC Accredited',
    description: 'A comprehensive legal education program preparing students for legal practice.',
    tuition_per_year: 200000,
    acceptance_fee: 60000,
    cutoff_score: 270,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[0],
  },
  {
    id: 'p4',
    institution_id: '2',
    slug: 'electrical-engineering-ui',
    name: 'Electrical and Electronics Engineering',
    degree_type: 'undergraduate',
    duration_years: 5,
    mode: 'full_time',
    accreditation_status: 'COREN Accredited',
    description:
      'Engineering program focusing on electrical systems, electronics, and telecommunications.',
    tuition_per_year: 150000,
    acceptance_fee: 45000,
    cutoff_score: 240,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[1],
  },
  {
    id: 'p5',
    institution_id: '2',
    slug: 'economics-ui',
    name: 'Economics',
    degree_type: 'undergraduate',
    duration_years: 4,
    mode: 'full_time',
    accreditation_status: 'NUC Accredited',
    description:
      'Comprehensive economics program covering micro and macroeconomics, econometrics, and development economics.',
    tuition_per_year: 120000,
    acceptance_fee: 40000,
    cutoff_score: 220,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[1],
  },
  {
    id: 'p6',
    institution_id: '3',
    slug: 'pharmacy-oau',
    name: 'Pharmacy',
    degree_type: 'undergraduate',
    duration_years: 5,
    mode: 'full_time',
    accreditation_status: 'PCN Accredited',
    description:
      'Professional pharmacy program training pharmacists in drug development and patient care.',
    tuition_per_year: 250000,
    acceptance_fee: 70000,
    cutoff_score: 260,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[2],
  },
  {
    id: 'p7',
    institution_id: '3',
    slug: 'mechanical-engineering-oau',
    name: 'Mechanical Engineering',
    degree_type: 'undergraduate',
    duration_years: 5,
    mode: 'full_time',
    accreditation_status: 'COREN Accredited',
    description:
      'Engineering program covering thermodynamics, mechanics, materials science, and manufacturing.',
    tuition_per_year: 160000,
    acceptance_fee: 50000,
    cutoff_score: 235,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[2],
  },
  {
    id: 'p8',
    institution_id: '4',
    slug: 'architecture-abu',
    name: 'Architecture',
    degree_type: 'undergraduate',
    duration_years: 6,
    mode: 'full_time',
    accreditation_status: 'ARCON Accredited',
    description:
      'Professional architecture program covering design, construction, and urban planning.',
    tuition_per_year: 180000,
    acceptance_fee: 55000,
    cutoff_score: 245,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[3],
  },
  {
    id: 'p9',
    institution_id: '5',
    slug: 'business-administration-covenant',
    name: 'Business Administration',
    degree_type: 'undergraduate',
    duration_years: 4,
    mode: 'full_time',
    accreditation_status: 'NUC Accredited',
    description:
      'Comprehensive business program covering management, marketing, finance, and entrepreneurship.',
    tuition_per_year: 850000,
    acceptance_fee: 150000,
    cutoff_score: 200,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[4],
  },
  {
    id: 'p10',
    institution_id: '5',
    slug: 'information-technology-covenant',
    name: 'Information Technology',
    degree_type: 'undergraduate',
    duration_years: 4,
    mode: 'full_time',
    accreditation_status: 'NUC Accredited',
    description:
      'IT program focusing on software development, network administration, and cybersecurity.',
    tuition_per_year: 900000,
    acceptance_fee: 150000,
    cutoff_score: 210,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[4],
  },
  {
    id: 'p11',
    institution_id: '6',
    slug: 'accounting-lasu',
    name: 'Accounting',
    degree_type: 'undergraduate',
    duration_years: 4,
    mode: 'full_time',
    accreditation_status: 'ICAN Accredited',
    description:
      'Professional accounting program preparing students for careers in auditing, taxation, and financial management.',
    tuition_per_year: 95000,
    acceptance_fee: 35000,
    cutoff_score: 215,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[5],
  },
  {
    id: 'p12',
    institution_id: '7',
    slug: 'computer-engineering-yabatech',
    name: 'Computer Engineering Technology',
    degree_type: 'hnd',
    duration_years: 2,
    mode: 'full_time',
    accreditation_status: 'NBTE Accredited',
    description: 'HND program in computer engineering covering hardware, software, and networking.',
    tuition_per_year: 65000,
    acceptance_fee: 25000,
    cutoff_score: 180,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[6],
  },
  {
    id: 'p13',
    institution_id: '8',
    slug: 'petroleum-engineering-unn',
    name: 'Petroleum Engineering',
    degree_type: 'undergraduate',
    duration_years: 5,
    mode: 'full_time',
    accreditation_status: 'COREN Accredited',
    description:
      'Engineering program focusing on oil and gas exploration, production, and refining.',
    tuition_per_year: 170000,
    acceptance_fee: 55000,
    cutoff_score: 255,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[7],
  },
  {
    id: 'p14',
    institution_id: '8',
    slug: 'mass-communication-unn',
    name: 'Mass Communication',
    degree_type: 'undergraduate',
    duration_years: 4,
    mode: 'full_time',
    accreditation_status: 'NUC Accredited',
    description:
      'Communication program covering journalism, broadcasting, public relations, and advertising.',
    tuition_per_year: 140000,
    acceptance_fee: 45000,
    cutoff_score: 210,
    status: 'published',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
    institution: mockInstitutions[7],
  },
];

// Mock Application Windows Data
export const mockApplicationWindows: ApplicationWindow[] = [
  {
    id: 'aw1',
    program_id: 'p1',
    application_start: '2025-03-01T00:00:00Z',
    application_end: '2025-05-31T23:59:59Z',
    screening_date: '2025-06-15T00:00:00Z',
    admission_list_date: '2025-07-10T00:00:00Z',
    acceptance_deadline: '2025-07-31T23:59:59Z',
    registration_start: '2025-08-01T00:00:00Z',
    registration_end: '2025-09-15T23:59:59Z',
    status: 'upcoming',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
  {
    id: 'aw2',
    program_id: 'p2',
    application_start: '2025-02-15T00:00:00Z',
    application_end: '2025-05-15T23:59:59Z',
    screening_date: '2025-06-01T00:00:00Z',
    admission_list_date: '2025-07-01T00:00:00Z',
    acceptance_deadline: '2025-07-20T23:59:59Z',
    registration_start: '2025-08-01T00:00:00Z',
    registration_end: '2025-09-10T23:59:59Z',
    status: 'upcoming',
    created_at: '2024-01-01T00:00:00Z',
    updated_at: '2024-01-10T00:00:00Z',
  },
];

// Helper function to get programs by institution
export function getProgramsByInstitution(institutionId: string): Program[] {
  return mockPrograms.filter((program) => program.institution_id === institutionId);
}

// Helper function to get institution by ID
export function getInstitutionById(id: string): Institution | undefined {
  return mockInstitutions.find((inst) => inst.id === id);
}

// Helper function to get program by ID
export function getProgramById(id: string): Program | undefined {
  return mockPrograms.find((prog) => prog.id === id);
}

// Helper function to filter institutions
export function filterInstitutions(filters: {
  type?: string;
  state?: string;
  verified?: boolean;
}): Institution[] {
  return mockInstitutions.filter((inst) => {
    if (filters.type && inst.type !== filters.type) return false;
    if (filters.state && inst.state !== filters.state) return false;
    if (filters.verified !== undefined && inst.verified !== filters.verified) return false;
    return true;
  });
}

// Helper function to search programs
export function searchPrograms(query: string): Program[] {
  const lowercaseQuery = query.toLowerCase();
  return mockPrograms.filter(
    (program) =>
      program.name.toLowerCase().includes(lowercaseQuery) ||
      program.description?.toLowerCase().includes(lowercaseQuery) ||
      program.institution?.name.toLowerCase().includes(lowercaseQuery)
  );
}
